import React from 'react';
import { motion } from 'framer-motion';
import { Quote } from 'lucide-react';
export function Testimonials() {
  return <section id="testimonials" className="py-20 bg-white" data-id="element-299">
      <div className="container mx-auto px-4 md:px-6" data-id="element-300">
        <div className="text-center mb-16" data-id="element-301">
          <h2 className="text-3xl md:text-4xl font-bold text-navy mb-4" data-id="element-302">
            Lo que dicen nuestros clientes
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="max-w-4xl mx-auto" data-id="element-303">
          <div className="bg-surface rounded-3xl p-8 md:p-12 relative" data-id="element-304">
            <Quote className="absolute top-8 left-8 w-12 h-12 text-primary/20" data-id="element-305" />

            <div className="relative z-10 flex flex-col md:flex-row gap-8 items-center" data-id="element-306">
              <div className="flex-1 text-center md:text-left" data-id="element-307">
                <p className="text-xl md:text-2xl font-medium text-navy italic leading-relaxed mb-6" data-id="element-308">
                  "Tu bienestar es nuestra prioridad absoluta. Resultados a
                  medida, rápidos y sin estrés. Nos encargamos de diseñar una
                  estrategia exclusiva para tu perfil, acompañándote en cada
                  paso del camino."
                </p>
                <div data-id="element-309">
                  <h4 className="text-lg font-bold text-primary" data-id="element-310">
                    Netdayris Cruz
                  </h4>
                  <p className="text-gray-500" data-id="element-311">CEO, NETCGSolutions</p>
                </div>
              </div>

              <div className="flex-shrink-0" data-id="element-312">
                <div className="w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden border-4 border-white shadow-lg" data-id="element-313">
                  <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?ixlib=rb-4.0.3&auto=format&fit=crop&w=400&q=80" alt="Netdayris Cruz" className="w-full h-full object-cover" data-id="element-314" />
                </div>
              </div>
            </div>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-12" data-id="element-315">
            {[{
            text: 'Gracias a su gestión conseguí mi visado de emprendedor en tiempo récord. Muy profesionales.',
            author: 'Carlos M.',
            role: 'Emprendedor'
          }, {
            text: 'Nos ayudaron con la movilidad de 5 empleados desde Latam. Todo perfecto y sin sorpresas.',
            author: 'TechSolutions SL',
            role: 'Empresa Tecnológica'
          }, {
            text: 'La asesoría fiscal me ha ahorrado muchos dolores de cabeza. 100% recomendados.',
            author: 'Ana P.',
            role: 'Autónoma'
          }].map((item, i) => <div key={i} className="bg-gray-50 p-6 rounded-xl border border-gray-100" data-id="element-316">
                <div className="flex gap-1 mb-3" data-id="element-317">
                  {[1, 2, 3, 4, 5].map(star => <span key={star} className="text-yellow-400" data-id="element-318">
                      ★
                    </span>)}
                </div>
                <p className="text-gray-600 text-sm mb-4" data-id="element-319">"{item.text}"</p>
                <p className="font-bold text-navy text-sm" data-id="element-320">{item.author}</p>
                <p className="text-xs text-gray-400" data-id="element-321">{item.role}</p>
              </div>)}
          </div>
        </motion.div>
      </div>
    </section>;
}